function returnEnvDataDog() {
  let envDataDog = '';

  switch (window.location.hostname) {
    case 'clubhouseqa.golftec.cn':
      envDataDog = 'staging-cn';
      break;
    case 'clubhouse.golftec.cn':
      envDataDog = 'prod-cn';
      break;
    case 'clubhouseqa.golftec.com.sg':
      envDataDog = 'staging-sg';
      break;
    case 'clubhouse.golftec.com.sg':
      envDataDog = 'prod-sg';
      break;
    case 'clubhouseqa.golftec.com.hk':
      envDataDog = 'staging-hk';
      break;
    case 'clubhouse.golftec.com.hk':
      envDataDog = 'prod-hk';
      break;
    case 'clubhouseqa.golftec.ca':
      envDataDog = 'staging-ca';
      break;
    case 'clubhouse.golftec.ca':
      envDataDog = 'prod-ca';
      break;
    case 'clubhouse.golftec.com':
      envDataDog = 'prod';
      break;
    case 'clubhousedev.golftec.com':
      envDataDog = 'dev';
      break;
    case 'clubhouseqa.golftec.com':
      envDataDog = 'staging';
      break;
    case 'clubhousedev.golfdigest.co.jp':
      envDataDog = 'dev-jp';
      break;
    case 'clubhouseqa.golfdigest.co.jp':
      envDataDog = 'staging-jp';
      break;
    case 'clubhouse.golfdigest.co.jp':
      envDataDog = 'prod-jp';
      break;
    case 'clubhouseqa.skytrakgolf.com':
      envDataDog = 'staging';
      break;
    case 'clubhousefieldtest.golftec.com':
      envDataDog = 'fieldtest';
      break;
    case 'clubhouseqa.golftec.ae':
      envDataDog = 'staging-ae';
      break;
    case 'clubhouse.golftec.ae':
      envDataDog = 'prod-ae';
      break;
    case 'clubhouseqa.golftec.co.za':
      envDataDog = 'staging-za';
      break;
    case 'clubhouse.golftec.co.za':
      envDataDog = 'prod-za';
      break;
    case 'clubhouse.skytrakgolf.com':
      envDataDog = 'prod';
      break;
    case 'clubhouse.skytrakgolf.jp':
      envDataDog = 'prod-jp';
      break;
    default:
      envDataDog = 'dev';
  }
  return envDataDog;
}

export default returnEnvDataDog;
